class LazyImage extends HTMLElement {
    _imgElement = null;
    _isSetUp = false;
    constructor() {
        super();
    }
    render() {
        const className = this.getAttribute("class");
        const src = this.getAttribute("src");
        const srcset = this.getAttribute("srcset");
        const alt = this.getAttribute("alt");
        let imgElement = this._imgElement;
        if (!imgElement) {
            imgElement = document.createElement("img");
            this._imgElement = imgElement;
        }
        imgElement.className = className || "d-flex";
        imgElement.src = src || "";
        imgElement.srcset = srcset || "";
        imgElement.alt = alt || "Lazy Image";
        imgElement.title = alt || "Lazy Image";
        imgElement.loading = "lazy";
        imgElement.decoding = "async";
        let widthVal = this.getAttribute("width");
        if (widthVal && widthVal.includes("%")) {
            imgElement.style.width = widthVal;
            imgElement.style.height = "auto";
        }
        else if (widthVal) {
            const pxWidth = parseInt(widthVal);
            if (!isNaN(pxWidth)) {
                imgElement.width = pxWidth;
            }
        }
        this._imgElement = imgElement;
        while (this.firstElementChild) {
            this.removeChild(this.firstElementChild);
        }
        this.appendChild(imgElement);
    }
    static get observedAttributes() {
        return ["class", "src", "srcset", "alt", "width", "loading"];
    }
    get src() {
        return this.getAttribute("src");
    }
    set src(value) {
        if (value) {
            this.setAttribute("src", value);
        }
        else {
            this.removeAttribute("src");
        }
    }
    connectedCallback() {
        this.render();
        this._isSetUp = true;
    }
    attributeChangedCallback(_name, oldValue, newValue) {
        if (this.isConnected && oldValue !== newValue) {
            this.render();
        }
    }
    disconnectedCallback() {
        this._isSetUp = false;
    }
}
customElements.define("component-lazy-image", LazyImage);
export default LazyImage;
